import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { WintSuperkollAPIModelTimeReporting as ApiModel } from "wint-api-client/dist/types";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TimeLogsViewContainerProps } from "models/propTypes/timeReportingProjectPropTypes";
import { FormikProps } from "formik";
//#endregion
//#region components
import TimeLogsForm from "./timeLogsForm";
//#endregion

const TimeLogsFormContainer: ForwardRefRenderFunction<FormHandles, TimeLogsViewContainerProps> = (props, ref) => {
  const {
    onTimeReportRowsChange,
    hiddenColumns,
    allowCheckBoxSelection,
    allowPagination,
    allowGrouping,
    compactTable,
    onlyBusinessUnits,
  } = props;

  const formRef = React.useRef<FormHandles>(null);
  React.useImperativeHandle(ref, () =>
    formRef.current
      ? {
          ...formRef.current,
        }
      : ({} as FormHandles)
  );

  const onTimeLogRowsChange = (
    name: string,
    updatedValue: ApiModel.TimeReportingReportRow[],
    formikProps: FormikProps<any>
  ) => {
    onTimeReportRowsChange && onTimeReportRowsChange(updatedValue);
  };

  return (
    <TimeLogsForm
      ref={formRef}
      defaultValues={{ rows: props.dataRows }}
      onRowsChange={onTimeLogRowsChange}
      hiddenColumns={hiddenColumns}
      allowCheckBoxSelection={allowCheckBoxSelection}
      allowPagination={allowPagination}
      allowGrouping={allowGrouping}
      compactTable={compactTable}
      onlyBusinessUnits={onlyBusinessUnits}
    />
  );
};

export default forwardRef(TimeLogsFormContainer);
